import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useMediaQuery } from 'react-responsive';

// Components
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import styles from './PageWrapper.module.scss';

function PageWrapper({
  title, children, hasWhiteWrapper, breadcrumb, ctaButton,
}) {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div>
      {breadcrumb ? (
        <Breadcrumb
          title={title}
          breadcrumb={breadcrumb}
        />
      ) : null}

      <div className="d-flex j-space-btw m-b-20 mobile-d-col">
        {title ? (
          <h1 className="fs-32 fw-600 c-neutral-01">{title}</h1>
        ) : null}

        {!isMobile ? ctaButton : null}
      </div>

      <div className={hasWhiteWrapper ? styles.inner_white : ''}>
        {children}

        {isMobile && ctaButton ? (
          <div className={styles.sticky_cta}>
            {ctaButton}
          </div>
        ) : null}
      </div>
    </div>
  );
}

PageWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  hasWhiteWrapper: PropTypes.bool,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({})),
  ctaButton: PropTypes.node,
};

PageWrapper.defaultProps = {
  title: null,
  hasWhiteWrapper: false,
  breadcrumb: null,
  ctaButton: null,
};

export default PageWrapper;
